import BiasActionCell from './BiasActionCell';

export default BiasActionCell;
